import { Department } from '@/modules/department'
import { User } from '@/modules/user'
import { BaseResource, PpUserRole, ResourcePermission, ResourceType, Team } from '@/schemas'

import { DimensionType } from '../dimensions'

export const ProductionRole = {
  负责人: '负责人',
  产品经理: '产品经理',
  项目经理: '项目经理',
  TO: 'TO',
  子TO: '子TO',
  成员: '成员',
} as const

export enum ProductionFlowStatus {
  待立项申请 = 'ProjectWaitForApply',
  待指派TO = 'TOWaitForAssign',
  待资源预估 = 'ResourceWaitForEstimate',
  待立项审批 = 'ProjectWaitForAudit',
  研发进行中 = 'DevOnGoing',
  待IPD审批 = 'IPDWaitForAudit',
  待产品验收 = 'ProductWaitForValidate',
  待项目结项 = 'ProjectWaitForFinish',
  项目已结项 = 'ProjectFinished',
  项目已驳回 = 'ProjectRejected',
  项目已关闭 = 'ProjectClosed',
}

export const ProductionTerminateFlowStatus = [
  ProductionFlowStatus.项目已驳回,
  ProductionFlowStatus.项目已结项,
  ProductionFlowStatus.项目已关闭,
] as const

export enum ProductionClassification {
  '平台-RTC' = 1,
  '平台-RTM' = 2,
  '平台-极速直播' = 3,
  '平台-融合CDN' = 4,
  '平台-RTSC' = 5,
  '平台-白板' = 6,
  产品配套 = 7,
  公司级专项 = 8,
  '泛娱乐-语聊' = 9,
  '泛娱乐-直播' = 10,
  '泛娱乐-专项' = 11,
  IOT = 12,
  教育 = 13,
  数字化 = 14,
  场景工具 = 15,
  '平台-AI' = 16,
}

export enum ProductionType {
  新产品 = 1,
  现有产品 = 2,
}

export enum Stage {
  新产品 = 'New',
  PMF = 'PMF',
  成熟产品 = 'Mature',
}

export enum ReviewFormActions {
  创建 = 0,
  通过 = 1,
  驳回 = 2,
  完成 = 3,
}

export interface ProductionAdditions {
  id: number
  selfId: string
  type: string
  subType: string
  field?: string
  value: string
}

export interface Production extends BaseResource, ResourcePermission {
  id: number
  selfId: string
  name: string
  email: string
  departmentId: number
  type: number
  to: string
  pgm: string
  startDate: Date
  endDate: Date
  progress: number
  classification: number
  stage: Stage
  trackingResult: string | null
  expectDeliveryTime: string | null
  confirmedDeliveryTime: string | null
  actualDeliveryTime: string | null
  projectType: ProductionType
  requirement: string
  situationDescription: string
  competition: string
  businessResult: string
  userAcceptance: string
  productQuality: string
  marketIndicators: string
  expectProductionTime: string
  expectTargetCheckTime: string
  flowStatus: ProductionFlowStatus
  jql: string | null
  predictWorkload: string | null
  actualWorkload: string | null
  background: string
  standard: string
  additions: ProductionAdditions[]
  roles: PpUserRole[]
  thisWeekReport: any

  readPermissions?: string[]

  createdAt: Date
  updatedAt: Date
  deletedAt?: any
  typeName: string
  user: User
  department: Department
  cycle: Cycle

  isFavourited: boolean

  risk: any
  lastestWrite: any
  resources: ProductionEstimateResource[]
  businessReport?: {
    report: string
    createTime: string
  }

  dimensions: {
    id: number
    projectSelfId: string
    resourceType: ResourceType
    dimensionId: number
    percentage: number
    dimension: {
      id: number
      name: string
      type: DimensionType
    }
  }[]
  hots: any[]
  flows: ProductionFLow[]
  historyRecords: HistoryRecord[]
}

export interface HistoryRecord {
  key: string
  updateType: 'init' | 'update'
  type: 'history' | 'flow' | 'nested'
  currentValue: string | null
  email?: string
  beforeValue: string | null
  createdAt: string
  additions: ProductionFLowAddition[]
}

export interface ProductionEstimateResourceUser {
  estimateResourceId: number
  email: string
}

export interface ProductionEstimateResource {
  id: number
  teamSelfId: string
  workload: number
  startDate: string
  endDate: string
  department?: Team
  users?: ProductionEstimateResourceUser[]
}

interface Cycle {
  name: string
  cycleId: number
}

export enum ValidateNotPassReason {
  功能未实现 = 'featureInComplete',
  指标未达成 = 'targetNotMet',
  其他 = 'other',
}

export interface ProductionFLow {
  id: number
  prevId: number | null
  status: ProductionFlowStatus
  createdAt: Date
  email?: string
  additions: ProductionFLowAddition[]
}

export interface ProductionFLowAddition {
  id: number
  productionFlowId: number
  type: string
  value: string
}

export const NoIPDAuditRequiredDayCount = 210 as const
